import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullscreenOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M5.626 29.735h10.519L4.714 41.165l2.122 2.121 11.43-11.43v10.519h3v-15.64H5.626zm37.66-22.9-2.121-2.121-11.431 11.431V5.625h-3v15.641h15.641v-3H31.856z" }) }) })
});
export default SvgFullscreenOff;
